(function () {
    var MenuUtils = window.HeaderMenuUtils || (window.HeaderMenuUtils = (function () {
      function safeParseJSON(text) {
        try { return JSON.parse(text); } catch (e) { return null; }
      }
  
      function esc(s) {
        return String(s == null ? "" : s)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
      }
  
      function runWhenIdle(fn, timeout) {
        if ("requestIdleCallback" in window) {
          requestIdleCallback(fn, { timeout: timeout || 800 });
        } else {
          setTimeout(fn, timeout ? Math.min(timeout, 200) : 100);
        }
      }
  
      function runAfterLoad(fn) {
        if (document.readyState === "complete") {
          runWhenIdle(fn);
        } else {
          window.addEventListener("load", function () {
            runWhenIdle(fn);
          }, { once: true });
        }
      }
  
      function debounce(fn, wait) {
        var t;
        return function () {
          var ctx = this;
          var args = arguments;
          clearTimeout(t);
          t = setTimeout(function () { fn.apply(ctx, args); }, wait || 140);
        };
      }
  
      function findByHandle(items, handle) {
        handle = String(handle || "");
        for (var i = 0; i < items.length; i++) {
          if (items[i] && String(items[i].handle) === handle) return items[i];
        }
        return null;
      }
  
      function createMenuDataStore(raw) {
        var dataParsed = false;
        var data = { items: [], settings: {} };
  
        function ensureData() {
          if (dataParsed) return;
          var parsed = raw ? safeParseJSON(raw) : null;
          data = parsed || { items: [], settings: {} };
          dataParsed = true;
        }
  
        return {
          getItem: function (handle) {
            ensureData();
            return findByHandle(data.items || [], handle);
          },
          getSettings: function () {
            ensureData();
            return data.settings || {};
          }
        };
      }
  
      return {
        safeParseJSON: safeParseJSON,
        esc: esc,
        runWhenIdle: runWhenIdle,
        runAfterLoad: runAfterLoad,
        debounce: debounce,
        findByHandle: findByHandle,
        createMenuDataStore: createMenuDataStore
      };
    })());
  
    function buildSubmenuHTML(item, settings) {
      if (!item || !item.children || !item.children.length) return "";
  
      var children = item.children;
      var html = '';
  
    //   html += '<div class="header__submenu list-menu list-menu--lv2 gradient motion-reduce list-unstyled" role="list" tabindex="-1">';
      html += '  <div class="submenu-wrapper scroll-style">';
      html += '    <ul>';
  
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (!child) continue;
  
        var hasLv3 = child.children && child.children.length;
        html += '      <li>';
  
        if (!hasLv3) {
          html += '        <a class="header__menu-item list-menu__item list-menu__item--lv2 link link--text link--hover focus-inset" href="' + MenuUtils.esc(child.url) + '">';
  
          if (child.image_46) {
            html += '          <image-animation class="card__media-wrapper media-wrapper--style" data-image-animate="zoom-fade-in">';
            html += '            <div class="media media--transparent media--zoom" style="width: 4rem; padding-bottom: 100%;">';
            html += '              <img width="46" height="46" loading="lazy" src="' + MenuUtils.esc(child.image_46) + '" alt="' + MenuUtils.esc(child.title) + '" />';
            html += '            </div>';
            html += '          </image-animation>';
          } else if (settings.no_image_fallback) {
            html += '          <img src="' + MenuUtils.esc(settings.no_image_fallback) + '" alt="No image" width="46" height="46" class="no-image" loading="lazy" />';
          }
  
          html += '          <span>' + MenuUtils.esc(child.title) + '</span>';
          html += '          <svg class="icon icon-caret" aria-hidden="true" focusable="false"><use href="#icon-menu-caret"></use></svg>';
          html += '        </a>';
        } else {
          var showTitle = false;
          for (var k = 0; k < child.children.length; k++) {
            if (child.children[k] && child.children[k].image_180) { showTitle = true; break; }
          }
  
          html += '        <div class="header__menu" is="header-submenu">';
          html += '          <a class="header__menu-item list-menu__item list-menu__item--lv2 link link--text link--hover focus-inset" href="' + MenuUtils.esc(child.url) + '">';
          html += '            <span>' + MenuUtils.esc(child.title) + '</span>';
          if (settings.enable_dropdown_icon) {
            html += '            <svg class="icon icon-caret" aria-hidden="true" focusable="false"><use href="#icon-menu-caret"></use></svg>';
          }
          html += '          </a>';
  
          html += '          <ul class="' + (showTitle ? 'submenu-has-slider ' : '') + 'header__submenu list-menu list-menu--lv3 gradient list-unstyled motion-reduce">';
          if (showTitle) {
            html += '            <li class="submenu-heading">' + MenuUtils.esc(child.title) + ' <a href="' + MenuUtils.esc(child.url) + '" class="link--hover"><span>Shop All</span></a></li>';
          }
  
          for (var j = 0; j < child.children.length; j++) {
            var grand = child.children[j];
            if (!grand) continue;
  
            html += '            <li class="' + (grand.image_180 ? 'has-image' : '') + '">';
            html += '              <a class="header__menu-item list-menu__item list-menu__item--lv3 link link--hover link--text focus-inset" href="' + MenuUtils.esc(grand.url) + '">';
            if (grand.image_180) {
              html += '                <img loading="lazy" src="' + MenuUtils.esc(grand.image_180) + '" alt="' + MenuUtils.esc(grand.title) + '">';
            }
            html += '                <span>' + MenuUtils.esc(grand.title) + '</span>';
            html += '              </a>';
            html += '            </li>';
          }
  
          html += '          </ul>';
          html += '        </div>';
        }
  
        html += '      </li>';
      }
  
      html += '    </ul>';
  
      var promo = item.promo || {};
      if (promo.image_550) {
        html += '    <div class="promotional-banner">';
        html += '      <image-animation class="card__media-wrapper media-wrapper--style ' + (promo.content_html ? 'has-content' : '') + '">';
        html += '        <img loading="lazy" src="' + MenuUtils.esc(promo.image_550) + '" alt="' + MenuUtils.esc(item.title) + '">';
        html += '      </image-animation>';
  
        if (promo.content_html) {
          html += '      <div class="promo-content">';
          html +=          promo.content_html;
          html += '        <a href="' + MenuUtils.esc(promo.link || item.url) + '" title="' + MenuUtils.esc(item.title) + '" class="action-promo">';
          html += '          <span>Shop Now</span>';
          html += '        </a>';
          html += '      </div>';
        }
        html += '    </div>';
      }
  
      var total = item.footer_total || children.length;
      html += '    <div class="footer-submemu" data-total="' + MenuUtils.esc(total) + '">';
      html += '      <p class="label">' + MenuUtils.esc(settings.menu_footer_text || "") + '</p>';
      html += '      <a href="' + MenuUtils.esc(item.url) + '" class="button button--large" title="' + MenuUtils.esc(item.title) + '">';
      html += '        <span>View All ' + MenuUtils.esc(total) + ' Subcategories</span>';
      html += '      </a>';
      html += '    </div>';
  
      html += '  </div>';
    //   html += '</div>';
  
      return html;
    }
  
    class HeaderWrapper extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia("(min-width: 1025px)");
        this.handleMediaChange = this.handleMediaChange.bind(this);
        this.handleFirstInteraction = this.handleFirstInteraction.bind(this);
        this._isInteractive = false;
        this._pendingActivate = false;
      }

      connectedCallback() {
        this.bindFirstInteraction();
        this.handleMediaChange(this.mql);
        if (this.mql.addEventListener) {
          this.mql.addEventListener("change", this.handleMediaChange);
        } else if (this.mql.addListener) {
          this.mql.addListener(this.handleMediaChange);
        }
      }

      initDataStore() {
        if (this._dataStoreInited) return;
        this._dataStoreInited = true;

        var jsonEl = document.getElementById("HeaderMenuJSON") || this.querySelector("#HeaderMenuJSON");
        var raw = jsonEl ? (jsonEl.textContent || "").trim() : "";
        this.store = MenuUtils.createMenuDataStore(raw);
      }

      handleMediaChange(e) {
        var isDesktop = !!(e && typeof e.matches === "boolean" ? e.matches : this.mql.matches);
        if (isDesktop) {
          this._pendingActivate = true;
          this.activate();
        } else {
          this.deactivate();
        }
      }

      bindFirstInteraction() {
        if (this._interactionBound) return;
        this._interactionBound = true;
        var opts = { once: true, passive: true };
        window.addEventListener("pointerdown", this.handleFirstInteraction, opts);
        window.addEventListener("keydown", this.handleFirstInteraction, opts);
        window.addEventListener("touchstart", this.handleFirstInteraction, opts);
        window.addEventListener("mousemove", this.handleFirstInteraction, opts);
      }

      handleFirstInteraction() {
        this._isInteractive = true;
        if (this._pendingActivate) this.activate();
      }

      isActive() {
        return !!this._active;
      }

      activate() {
        if (this._active || !this._isInteractive) return;
        this._active = true;

        this.initDataStore();
        this._lastStructureSignature = this.getStructureSignature();
        this._onResize = MenuUtils.debounce(() => {
          var signature = this.getStructureSignature();
          if (signature === this._lastStructureSignature) return;
          this._lastStructureSignature = signature;
          this.prefetchCache();
        }, 160);

        window.addEventListener("resize", this._onResize, { passive: true });
        this.prefetchCache();
      }

      deactivate() {
        if (!this._active) return;
        this._active = false;
        this._pendingActivate = false;

        if (this._onResize) {
          window.removeEventListener("resize", this._onResize);
        }
      }

      closeAll(exceptHandle) {
        this.querySelectorAll("header-submenu").forEach((el) => {
          if (exceptHandle && el.getAttribute("data-handle") === exceptHandle) return;
          if (typeof el.close === "function") el.close();
        });
      }

      getItem(handle) {
        if (!this.store) return null;
        return this.store.getItem(handle);
      }

      getSettings() {
        if (!this.store) return {};
        return this.store.getSettings();
      }

      getStructureSignature() {
        var mounts = this.querySelectorAll("header-submenu [data-submenu-mount]");
        return String(mounts.length);
      }

      prefetchCache() {
        var self = this;

        var run = function () {
          if (!self._active) return;
          var nodes = self.querySelectorAll("header-submenu [data-submenu-mount]");
          var i = 0;

          var step = function () {
            if (!self._active) return;
            var start = Date.now();

            while (i < nodes.length && (Date.now() - start) < 12) {
              var mount = nodes[i];
              i += 1;

              if (!mount || mount.dataset.rendered) continue;

              var host = mount.closest("header-submenu");
              var handle = host ? host.getAttribute("data-handle") : null;
              if (!handle) continue;

              var item = self.getItem(handle);
              var settings = self.getSettings();

              mount.innerHTML = buildSubmenuHTML(item, settings);
              mount.dataset.rendered = "true";
              mount.hidden = true;
            }

            if (i < nodes.length) {
              if ("requestIdleCallback" in window) {
                requestIdleCallback(step, { timeout: 600 });
              } else {
                setTimeout(step, 50);
              }
            }
          };

          step();
        };

        MenuUtils.runAfterLoad(run);
      }

      disconnectedCallback() {
        if (this.mql && this.mql.removeEventListener) {
          this.mql.removeEventListener("change", this.handleMediaChange);
        } else if (this.mql && this.mql.removeListener) {
          this.mql.removeListener(this.handleMediaChange);
        }

        if (this._onResize) {
          window.removeEventListener("resize", this._onResize);
        }
      }
    }
  
    class HeaderSubmenu extends HTMLElement {
      connectedCallback() {
        if (this._inited) return;
        this._inited = true;
  
        this.root = this.closest("header-main-menu");
        this.handle = this.getAttribute("data-handle");
        this.trigger = this.querySelector("[data-submenu-trigger]");
        this.mount = this.querySelector("[data-submenu-mount]");
  
        if (!this.root || !this.handle || !this.trigger || !this.mount) return;
  
        this._onClick = (e) => {
          if (!this.root.isActive || !this.root.isActive()) return;
          e.preventDefault();
  
          var isOpen = this.trigger.getAttribute("aria-expanded") === "true";
          if (isOpen) {
            this.close();
            return;
          }
  
          this.root.closeAll(this.handle);
  
          if (!this.mount.dataset.rendered) {
            var item = this.root.getItem(this.handle);
            var settings = this.root.getSettings();
            this.mount.innerHTML = buildSubmenuHTML(item, settings);
            this.mount.dataset.rendered = "true";
          }
  
          this.open();
        };
  
        this.trigger.addEventListener("click", this._onClick);
      }
  
      open() {
        this.trigger.setAttribute("aria-expanded", "true");
        this.mount.hidden = false;
      }
  
      close() {
        this.trigger.setAttribute("aria-expanded", "false");
        this.mount.hidden = true;
      }
  
      disconnectedCallback() {
        if (this.trigger && this._onClick) {
          this.trigger.removeEventListener("click", this._onClick);
        }
      }
    }
  
    if (!customElements.get("header-main-menu")) {
      customElements.define('header-main-menu', HeaderWrapper);
    }
  
    if (!customElements.get("header-submenu")) {
      customElements.define("header-submenu", HeaderSubmenu);
    }  

    document.addEventListener('DOMContentLoaded', function () {
      var btn = document.querySelector('.sticky-search');
      var box = document.querySelector('.header-content-search');
  
      if (btn && box) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var openMenus = document.querySelectorAll('header-submenu.header__menu.active');
          for (var i = 0; i < openMenus.length; i++) {
            openMenus[i].classList.remove('active');
          }
          box.classList.toggle('active');
        });
      }
  
      document.addEventListener('click', function (e) {
        var menuLink = e.target.closest('.header__menu > a.header__menu-item');
        if (menuLink) {
          e.preventDefault();
          e.stopImmediatePropagation();
  
          var parentMenu = menuLink.closest('.header__menu');
          var firstLv1 = document.querySelector('.header__menu-item');
          var isActive = parentMenu && parentMenu.classList.contains('active');
  
          if (firstLv1) firstLv1.classList.remove('active');
  
          document.querySelectorAll('.header__menu-item.list-menu__item--lv1').forEach(function (menuLinkEl) {
            menuLinkEl.classList.remove('active');
          });
  
          document.querySelectorAll('.header__menu').forEach(function (menu) {
            menu.classList.remove('active');
          });
  
          if (parentMenu && !isActive) {
            parentMenu.classList.add('active');
          }
  
          return;
        }
  
        if (!e.target.closest('.header__menu')) {
          document.querySelectorAll('.header__menu').forEach(function (menu) {
            menu.classList.remove('active');
          });
        }
  
        if (btn && box && !box.contains(e.target) && !btn.contains(e.target)) {
          box.classList.remove('active');
        }
      });
    });
  })();
  